import { ErrorHandler, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AnalyticsService } from './analytics.service';
import { ProfileService } from '../app/profile.service';
import { environment } from '../../../../environments/environment';

const MAX_LAST_ERRORS_STORE = 10;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly analytics = inject(AnalyticsService);
  private readonly profile = inject(ProfileService);

  private lastErrors = signal<string[]>([]);

  async handleError(error: any) {
    const body = {
      datetime: new Date(),
      environment: {
        version: environment.version,
        production: environment.production,
      },
      error: {
        message: error?.message ?? error?.error?.message,
        stack: error?.stack,
      },
      context: {
        url: this.router.url,
        userAgent: navigator.userAgent,
        analyticsHistory: this.analytics.history,
        profile: this.profile.decodeToken(),
      },
    };

    const errorSignature = JSON.stringify(body.error);

    if (this.lastErrors().includes(errorSignature)) {
      return;
    }

    this.lastErrors.update((current) => {
      return [errorSignature, ...current].slice(0, MAX_LAST_ERRORS_STORE);
    });

    console.error(error);

    await firstValueFrom(this.http.put('/frontend-log', body));
  }
}
